import sentryhelper from '~/helpers/sentryhelper'

export default (ctx) => {
  sentryhelper.init(ctx)
}
